<template>
  <div class="member-area-tab-color-config-component">
    <h5 class="text-semibold mb-4">
      Qual modo de cor você deseja?
    </h5>
    <div class="row">
      <div class="col-lg-6 py-3">
        <div
          class="card-box p-5"
          :class="{ selected: form.config.style === 'dark' }"
        >
          <div
            class="d-flex justify-content-between align-items-center mb-7 w-100"
          >
            <h5>Modo escuro</h5>
            <input
              id="checkbox-dark-theme"
              class="input-radio"
              type="radio"
              v-model="form.config.style"
              value="dark"
            />
          </div>
          <div class="image-container">
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center gap-2 mb-7">
                <i class="ph ph-desktop" />
                <h5>Desktop</h5>
              </div>
              <img
                src="@/assets/images/member-area/dark-mode-desktop.svg"
                alt="desktop"
                class="img-fluid"
              />
            </div>
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center gap-2 mb-7">
                <i class="ph ph-device-mobile-camera" />
                <h5>Mobile</h5>
              </div>
              <img
                src="@/assets/images/member-area/dark-mode-mobile.svg"
                alt="desktop"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 py-3">
        <div
          class="card-box p-5"
          :class="{ selected: form.config.style === 'light' }"
        >
          <div
            class="d-flex justify-content-between align-items-center mb-7 w-100"
          >
            <h5>Modo claro</h5>
            <input
              id="checkbox-dark-theme"
              class="input-radio"
              type="radio"
              v-model="form.config.style"
              value="light"
            />
          </div>
          <div class="image-container">
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center gap-2 mb-7">
                <i class="ph ph-desktop" />
                <h5>Desktop</h5>
              </div>
              <img
                src="@/assets/images/member-area/light-mode-desktop.svg"
                alt="desktop"
                class="img-fluid"
              />
            </div>
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center gap-2 mb-7">
                <i class="ph ph-device-mobile-camera" />
                <h5>Mobile</h5>
              </div>
              <img
                src="@/assets/images/member-area/light-mode-mobile.svg"
                alt="desktop"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style lang="scss" scoped>
.member-area-tab-color-config-component {
  input[type="checkbox"]:disabled {
    background-color: #fff !important;
  }
  .card-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: fit-content;
    padding: 20px 20px 48px 20px !important;
    .image-container {
      display: flex;
      gap: 48px;
      max-width: 75%;
    }
  }

  .input-radio:checked:after {
    padding: 0px 0px 2px 0px;
    background-color: var(--blue);
    font-size: 14px;
    color: var(--light);
  }
}
</style>
